import { signal } from '@preact/signals';

import { de } from './locales/de';
import { en } from './locales/en';
import { es } from './locales/es';
import { fr } from './locales/fr';
import { it } from './locales/it';
import { nb } from './locales/nb';

export type Locale = 'en' | 'fr' | 'it' | 'es' | 'de' | 'nb';

export type TranslationMap = Record<string, string>;

const locales: Record<Locale, TranslationMap> = { en, fr, it, es, de, nb };

export const currentLocale = signal<Locale>('en');

export function setLocale(locale: Locale): void {
  if (locales[locale]) {
    currentLocale.value = locale;
  } else {
    console.warn(`[i18n] Unknown locale: ${locale}`);
  }
}

export function getLocale(): Locale {
  return currentLocale.value;
}

export function initLocale(): void {
  const raw =
    ((window as any).Shopify?.locale as string | undefined) || document.documentElement.lang;
  if (!raw) return;
  const lang = raw.split('-')[0] as Locale;
  setLocale(lang);
}

export function t(key: string, params?: Record<string, string>): string {
  const map = locales[currentLocale.value] || locales.en;
  let value = map[key] ?? locales.en[key] ?? key;

  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
    });
  }

  return value;
}
